// discussion on how to query for multiple records by id: https://community.airtable.com/t5/development-apis/how-to-query-multiple-records/td-p/118336
export function formulaGetAllIds(ids: string[]): string {
  return `OR(${ids.map((id) => `RECORD_ID()="${id}"`)})`;
}
